import { createAsyncThunk } from '@reduxjs/toolkit';

export const removeApplication = createAsyncThunk<string, number>(
  'TMP_ACTION',
  () => Promise.resolve('ok'),
);
